import { Box } from "@chakra-ui/layout";
import React from "react";

const Footer = () => {
  return (
    <Box textAlign="center" p="40px" color="#ffffffd4">
      2021 &copy; Zora
    </Box>
  );
};

export default Footer;
